import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function Audit() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/audit", { params: { limit: 300 } }).then((r)=>setItems(r.data)); }, []);
  return (
    <div className="p-4 md:p-6 space-y-4">
      <h1 className="text-xl font-medium tracking-tight">Audit Log</h1>
      <div className="bg-card border border-border/60 overflow-auto max-h-[calc(100vh-160px)]">
        <table className="w-full text-xs">
          <thead className="text-[10px] uppercase tracking-widest text-muted-foreground bg-background/20 sticky top-0">
            <tr><th className="text-left px-3 py-1.5 font-normal">Time</th><th className="text-left px-3 py-1.5 font-normal">Event</th><th className="text-left px-3 py-1.5 font-normal">User</th><th className="text-left px-3 py-1.5 font-normal">Meta</th></tr>
          </thead>
          <tbody>
            {items.map((e) => (
              <tr key={e.id} className="border-t border-border/40">
                <td className="px-3 py-1.5 mono whitespace-nowrap">{new Date(e.created_at).toLocaleString()}</td>
                <td className="px-3 py-1.5 mono">{e.event}</td>
                <td className="px-3 py-1.5 mono text-muted-foreground">{e.user_id?.slice(0,8) || "—"}</td>
                <td className="px-3 py-1.5 mono text-muted-foreground truncate max-w-[420px]">{JSON.stringify(e.meta)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
